export default __webpack_public_path__ + "static/media/profile-picture.af8cb920.png";